<template>
  <div id="contenedor-nueva-respuesta">
    <v-form
      v-model="formularioValido"
      ref="registraNuevaAuditoriaInformeRepuesta">
      <v-card>
        <v-card-title>
          Nueva Respuesta
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <TextField
                v-model="respuesta.numeroOficio"
                label="Número Oficio"
                :rules="[mixReglas.requerido]">
              </TextField>
            </v-col>
            <v-col  cols="12" md="6">
                <custom-date-picker
                v-model="respuesta.fecha"
                label="Fecha Oficio"
                :rules="[mixReglas.requerido]">
                </custom-date-picker>
            </v-col>
            <v-col  cols="12" md="6">
                <CustomDatePicker
                v-model="respuesta.fechaEntrega"
                label="Fecha Entrega"
                >
                </CustomDatePicker>
            </v-col>
            <v-col cols="12" md="12">
              <TextArea
                v-model="respuesta.comentarios"
                label="Comentarios"
                rows="3">
              </TextArea>
            </v-col>
          </v-row>
          <v-card class="selected ma-4 pa-4" flat>
          <v-row align="center" justify="center">
            <v-file-input
            v-show="false"
            show-size
            label="Seleccionar Archivo PDF"
            type="file"
            ref="anexoDocumento"
            name="anexo"
            id="anexo"
            accept=".pdf"
            @change="seleccion"
            >
            </v-file-input>
            <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                <v-icon center>
                  mdi-paperclip
                </v-icon>
            </v-btn>
            <template v-if="nombreArchivoSeleccionado">
              <span
              class="text-caption font-weight-light secondary--text "
              >{{ nombreArchivoSeleccionado }}</span>
            </template>
            <template v-else>
              <span class="text-caption font-weight-light secondary--text">
              ... </span>
            </template>
          </v-row>
          <v-row align="center" justify="center">
          <custom-button
          class="mx-4 text-caption font-weight-light"
          tipo="formCancelar"
          :label="rutaArchivo ? 'Cambiar' : 'Seleccionar Archivo'"
          @click="seleccionarArchivo">
          </custom-button>
          </v-row>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextField from '@/components/inputs/sinColumnas/TextField.vue';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import mixRespuestas from './mixRespuestas';

export default {
  name: 'RegistrarNuevaRespuesta',
  mixins: [mixRespuestas],
  props: {
    informe: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextField,
    TextArea,
    CustomButton,
    CustomDatePicker,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      rutaArchivo: null,
      nombreArchivoSeleccionado: null,
      archivoAnexo: null,
      respuesta: {
        idInforme: this.informe.id,
        consecutivo: 0,
        numeroOficio: '',
        fecha: '',
        fechaEntrega: '',
        comentarios: null,
        dataFile: '',
      },
    };
  },
  methods: {
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      if (this.nombreArchivoSeleccionado !== null) {
        const archivo = await this.mixSubirArchivo(datosArchivo);
        if (archivo.status === 'ok') {
          this.respuesta.dataFile = JSON.stringify(archivo.data);
        }
      }
      await this.mixAgregarRespuesta();
    },
    limpiarFormularioRespuestas() {
      this.$refs.registraNuevaAuditoriaInformeRepuesta.reset();
    },
    cerrar() {
      this.limpiarFormularioRespuestas();
      this.$emit('cerrar');
    },
    seleccion() {
      if (document.getElementById('anexo').files.length === 1) {
        this.rutaArchivo = URL.createObjectURL(
          document.getElementById('anexo').files[0],
        );
        [this.nombreArchivoSeleccionado] = document.getElementById('anexo')
          .files[0].name.split('.');
      }
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    setDatosArchivo() {
      const datos = {
        nombre: 'respuesta',
        path: 'Auditorias/informes/respuestas',
      };
      return datos;
    },
  },
};
</script>

<style lang="scss">

</style>
